export const MIN_ZOOM = 100;
export const MAX_ZOOM = 300;
export const POPOVER_PROPS = {
  placement: 'bottom-start'
};
//# sourceMappingURL=constants.js.map